
import {
    defineComponent,
    inject,
    ref,
    onMounted,
    reactive,
    provide
} from 'vue'

//icons
import {
    ArrowLeft
} from '@element-plus/icons-vue'

//components
import sPerson from "@/components/wizard/steps/sPerson.vue";
import PhotoManager from "@/views/persons/photo/PhotoManager.vue";
import sFiles from "@/components/wizard/steps/sFiles.vue";
import sAcademic from "@/components/wizard/steps/StepAcademic.vue"
import sCompetition from "@/components/wizard/steps/StepCompetition.vue"

//services
import masterService from "@/core/services/MasterService";
import acrdService from "@/core/services/AcrdService";
import FileService from "@/core/services/FileService";
import { errManager } from "@/core/config/Tools";

import type { FormInstance, FormRules, Action } from "element-plus";
import { ElMessageBox } from 'element-plus'

export default defineComponent({
    name: "modal-acrd",
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        typeRegister: {
            type: String,
            required: true,
            default: ''
        },
    },
    components: {
        sPerson, PhotoManager, sAcademic, sCompetition, sFiles
    },
    setup(props) {
        const loading = ref(false)
        const gblDialogAcrd = inject('gblDialogAcrd')
        const gblRowAcrd = inject<any>('gblRowAcrd')
        const currentStepIndex = ref(1);
        const listStatus = ref<any>([])
        const formRec = ref<FormInstance>()
        const form = reactive(<any>{})
        const rules = reactive<FormRules>({
            checkdoc: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            },],
            message: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            },],
        })

        const listTypeFile = ref<any[]>([])

        provide("listTypeFile", listTypeFile)

        const onOpened = () => {
            currentStepIndex.value = 1
            getListTypeFile()
        }

        const onClosed = () => {
            currentStepIndex.value = 0
            gblRowAcrd.value = {}
        }

        const getListTypeFile = async () => {
            listTypeFile.value = []
            await FileService.getFiles2('acrd', 'type', { tregister: props.typeRegister, idevent: gblRowAcrd.value.idevent, idsport: gblRowAcrd.value.idsport })
                .then((res) => {
                    listTypeFile.value = res.data
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        //lista de estados de acreditacion
        const getStatus = async () => {
            await masterService.Details("api", btoa("6"))
                .then((res) => {
                    listStatus.value.length = 0
                    listStatus.value = res.data
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    saveForm()

            });
        };

        const saveForm = async () => {
            loading.value = true
            form.idacrd = gblRowAcrd.value.idacreditation
            await acrdService.changeStatus('acreditation', form)
                .then((res) => {
                    loading.value = false
                    if (res.data.status) {
                        ElMessageBox.alert(res.data.message, process.env.VUE_APP_NAME, {
                            confirmButtonText: 'OK',
                            callback: (action: Action) => {
                                resetForm(formRec.value)
                            },
                        })
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const aproved = async () => {
            loading.value = true
            await acrdService.changeStatus('acreditation', {
                idacrd: gblRowAcrd.value.idacreditation,
                checkdoc: 1,
                message: "Aprobado"
            })
                .then((res) => {
                    loading.value = false
                    if (res.data.status) {
                        gblRowAcrd.value.checkdoc = 1
                        gblRowAcrd.value.check_class = 'success'
                        gblRowAcrd.value.check_name = 'Aprobado'
                        ElMessageBox.alert(res.data.message, process.env.VUE_APP_NAME, {
                            confirmButtonText: 'OK',
                            callback: (action: Action) => {
                                //dialogAcreditation.value = false
                            },
                        })
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getStatus()
        })



        return {
            loading,
            gblDialogAcrd,
            ArrowLeft,
            currentStepIndex,
            gblRowAcrd,
            formRec,
            form,
            rules,
            listStatus,
            //events
            onOpened,
            onClosed,
            getListTypeFile,
            resetForm,
            submitForm,
            aproved

        }

    },
})
